<template>
<div class="chapter">
<div class="inner_page">
<h3 class="ChTitle" id="ch23"><a id="ch23a"></a><a id="page_52"></a><a href="#/Contents#rch23"><span class="underline">IT COULD ONLY HAPPEN IN…</span></a></h3>
<p class="center1"><span><i>Ever hear about some odd thing that occurs and find yourself saying, “That could only happen in ____”? That’s how we felt about these stories.</i></span></p>
<p class="noindent1s"><span><b>…DUBAI</b></span></p>
<p class="noindent"><span>In 2008 the luxury hotel chain Palazzo Versace announced that they were building a plush resort in the Middle Eastern jet-setting hot spot Dubai. Besides all of the usual luxurious amenities stuff you’d expect to find at such a $2.3 billion resort—five-star hotel, gourmet restaurants, luxury spas, etc.—the resort will feature a…refrigerated beach. The plans provide for refrigeration lines to be laid under the sand so that visitors won’t burn their feet.</span></p>
<p class="noindent1s"><span><b>…TEXAS</b></span></p>
<p class="noindent"><span>In July 2012, restaurateur Doug Guller purchased the central Texas “ghost town” of Bankersmith on eBay and promptly announced he’d be changing the name to “Bikinis,” which is the name of his sports-bar chain (staffed, of course, by women wearing bikinis). “Bikinis, Texas,” Guller said in a press release, “will be a world-class destination, and I am thrilled to expand the Bikinis brand to include town ownership.”</span></p>
<p class="noindent1s"><span><b>…IRELAND</b></span></p>
<p class="noindent"><span>The Mullingar Equestrian Centre, located about an hour from Dublin, had to cancel its 2006 Christmas party after a resident camel entered the party area and drank several cans of Guinness. (It bit through the cans to get to the beer.) The intoxicated beast then ate the 200 meat pies that had been laid out for guests. The camel, named Gus, had somehow escaped from his pen when staff left to change for the event. “You couldn’t blame him,” said owner Robert Fagan. “He’s really a very gentle, docile sort of camel.”</span></p>
<div class="box">
<p class="center7"><span><b>It takes the silk of 2,000 silkworm cocoons to make one kimono.</b></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter023.vue?1d21e968